import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

/**
 * Get payment history with optional filters
 * @param {Object} params - Query parameters
 * @param {string} params.startDate - Start date in ISO format (YYYY-MM-DD)
 * @param {string} params.endDate - End date in ISO format (YYYY-MM-DD)
 * @param {string} params.sourceType - Payment source type (Invoice, Offer, Ticket)
 * @param {string} params.paymentMethod - Payment method (Cash, Bancontact, Veriment)
 * @returns {Promise} Payment history data
 */
export const getPaymentHistory = async (params = {}) => {
  try {
    // Build query string from params
    const queryParams = new URLSearchParams();
    
    if (params.startDate) {
      queryParams.append('startDate', params.startDate);
    }
    
    if (params.endDate) {
      queryParams.append('endDate', params.endDate);
    }
    
    if (params.sourceType && params.sourceType !== '') {
      queryParams.append('sourceType', params.sourceType);
    }
    
    if (params.paymentMethod && params.paymentMethod !== '') {
      queryParams.append('paymentMethod', params.paymentMethod);
    }
    
    const queryString = queryParams.toString();
    const url = `/Payments/history${queryString ? `?${queryString}` : ''}`;
    
    return await axiosInstance.get(url);
  } catch (error) {
    console.error('Error fetching payment history:', error);
    throw error;
  }
};

/**
 * Get payments by customer ID
 * @param {number} customerId - Customer ID
 * @returns {Promise} Customer payments
 */
export const getPaymentsByCustomerId = async (customerId) => {
  try {
    return await axiosInstance.get(`/Payments/customer/${customerId}`);
  } catch (error) {
    console.error('Error fetching customer payments:', error);
    throw error;
  }
};

/**
 * Get payment details by ID
 * @param {number} id - Payment ID
 * @returns {Promise} Payment details
 */
export const getPaymentById = async (id) => {
  return await axiosInstance.get(`/Payments/${id}`);
};

/**
 * Record a new payment
 * @param {Object} paymentData - Payment data
 * @returns {Promise} Created payment
 */
export const recordPayment = async (paymentData) => {
  return await axiosInstance.post('/Payments', paymentData);
};

/**
 * Update payment
 * @param {number} id - Payment ID
 * @param {Object} paymentData - Updated payment data
 * @returns {Promise} Updated payment
 */
export const updatePayment = async (id, paymentData) => {
  return await axiosInstance.put(`/Payments/${id}`, paymentData);
};

/**
 * Delete payment
 * @param {number} id - Payment ID
 * @returns {Promise}
 */
export const deletePayment = async (id) => {
  return await axiosInstance.delete(`/Payments/${id}`);
};

/**
 * Get payment statistics
 * @param {Object} params - Query parameters
 * @returns {Promise} Payment statistics
 */
export const getPaymentStatistics = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.startDate) {
      queryParams.append('startDate', params.startDate);
    }
    
    if (params.endDate) {
      queryParams.append('endDate', params.endDate);
    }
    
    const queryString = queryParams.toString();
    const url = `/Payments/history${queryString ? `?${queryString}` : ''}`;
    
    return await axiosInstance.get(url);
  } catch (error) {
    console.error('Error fetching payment statistics:', error);
    throw error;
  }
};